import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './styles.module.scss'
import { OverviewTab } from './overviewTab'
import { OpticsTab } from './opticsTab'
import { LinkedFundingTab } from './linkedFundingTab'
import { ApiKeysTab } from './apiKeysTab'
import { BaseClaimApiTestView } from '../baseClaimApiTestView'

type TabId = 'overview' | 'optics' | 'linked-funding' | 'test-suite' | 'keys'

const TABS: { id: TabId; label: string; path: string }[] = [
    { id: 'overview', label: 'Overview', path: '/fairclaim-api' },
    { id: 'optics', label: 'Data Optics', path: '/fairclaim-api/optics' },
    { id: 'linked-funding', label: 'Linked Funding', path: '/fairclaim-api/linked-funding' },
    { id: 'test-suite', label: 'API Test Suite', path: '/fairclaim-api/test-suite' },
    { id: 'keys', label: 'API Keys', path: '/fairclaim-api/keys' },
]

export const FairclaimApiView = () => {
    const location = useLocation()
    const navigate = useNavigate()

    const active: TabId = location.pathname.endsWith('/linked-funding')
        ? 'linked-funding'
        : location.pathname.endsWith('/optics')
          ? 'optics'
          : location.pathname.endsWith('/test-suite')
            ? 'test-suite'
            : location.pathname.endsWith('/keys')
              ? 'keys'
              : 'overview'

    return (
        <div className={styles.hub}>
            <div className={styles.tabBar}>
                {TABS.map((tab) => (
                    <button
                        key={tab.id}
                        className={active === tab.id ? styles.tabActive : styles.tab}
                        onClick={() => navigate(tab.path)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            {active === 'overview' && <OverviewTab />}
            {active === 'optics' && <OpticsTab />}
            {active === 'linked-funding' && <LinkedFundingTab />}
            {active === 'test-suite' && <BaseClaimApiTestView />}
            {active === 'keys' && <ApiKeysTab />}
        </div>
    )
}
